import SitePage from '../components/SitePage';
import '../App.css';

function UserPage({ assets }) {
  return <SitePage assets={assets} />;
}

export default UserPage;
